<template>
<div :class="{'container-fluid' : !isSettingsComponent}">
	<equipment-toolbar v-if="!isSettingsComponent" heading="Equipment Types">
		<equipment-list-nav-tabs></equipment-list-nav-tabs>
	</equipment-toolbar>

	<collapsible-panel :always-open="true" panel-size="sm">

		<template slot="panel">
			<panel-menu 
				:menu-items="menuItems" 
				:active-item="activeSection"
				v-on:itemClick="panelItemClick">
			</panel-menu>
		</template>
		<component :is="isSettingsComponent ? 'div' : 'template'" slot="main">

			<div class="row">
				<div v-if="activeSection == 'Equipment Types' || activeSection == 'All'" :class="{'col-xl-8':activeSection == 'All','col-12': activeSection != 'All'}">

					<widget title="Equipment Types">

						<table-list
							:loading="loading"
							:fields="typeFields"
							:records="mutatedTypes"
							record-name="Equipment Type"
							id-field="slug"
							:has-edit="true"
							:has-delete="true"
							delete-endpoint="EquipmentType/delete"
							:sortable="true"
							v-on:edit="editType"
							v-on:modelChange="fetchTypes">

							<button class="btn btn-success" v-on:click="newType">
								<i class="fa fa-plus"></i>
								New Equipment Type
							</button>

						</table-list>

						<equipment-type-edit-modal 
							:visible="editModal.visible"
							:title="editModal.title"
							:record="editModal.record"
							v-on:closeModal="editModal.visible = false"
							v-on:modelChanged="fetchTypes">
						</equipment-type-edit-modal>

					</widget>
				</div>
				<div v-if="activeSection == 'Categories' || activeSection == 'All'" :class="{'col-xl-4':activeSection == 'All','col-12': activeSection != 'All'}">
					<widget title="Equipment Categories">

						<table-list
							:loading="loading"
							:fields="categoryFields"
							:records="equipmentCategories"
							record-name="Equipment Categorie"
							id-field="slug"
							:has-edit="false"
							:has-delete="true"
							delete-endpoint="EquipmentCategory/delete"
							:sortable="true"
							:hide-record-count="true"
							v-on:modelChange="fetchCategories">

							<form v-on:submit.prevent="addCategory">

								<div class="d-flex align-items-center flex-wrap">

									<label class="mr-2 mb-0 font-weight-bold">Add Category</label>

									<field :params="{placeholder:'Category Name'}" v-model="catName"></field>

									<div>
										<button 
											type="submit" 
											class="btn btn-success">
											<i class="fa fa-save"></i>
											Add
										</button>
									</div>

								</div>
							</form>

						</table-list>

					</widget>
				</div>
				<div v-if="activeSection == 'Maintenance Events' || activeSection == 'All'" :class="{'col-xl-12':activeSection == 'All','col-12': activeSection != 'All'}">

					<widget title="Equipment Maintenance Events">
						<equipment-maintenance-events></equipment-maintenance-events>
					</widget>

				</div>
			</div>

		</component>

	</collapsible-panel>

</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "./EquipmentToolbar"	
import TableList from "@/components/TableList"
import EquipmentTypeEditModal from "@/components/super_components/EquipmentTypeEditModal"
import Widget from "@/components/Widget"
import Field from "@/components/Field"
import EquipmentListNavTabs from "./EquipmentListNavTabs"
import EquipmentMaintenanceEvents from "./EquipmentMaintenanceEvents"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

export default {
	name: "EquipmentTypes",
	components: {
		EquipmentToolbar,
		TableList,
		EquipmentTypeEditModal,
		CollapsiblePanel,
		PanelMenu,
		Widget,
		Field,
		EquipmentListNavTabs,
		EquipmentMaintenanceEvents
	},
	props: ["isSettingsComponent"],
	data() {
		return {
			menuItems: [
				"All",
				"Equipment Types",
				"Categories",
				"Maintenance Events"
			],
			activeSection: "All",
			typeFields: [
				{label: "Name",key:"name"},
				{label: "Category",key:"catName"},
				{label: "Charge Out Rate(s)",key:"chargeOutRates",align:"right"},
				{label: "Cost per Hour",key:"default_cost_hr",align:"right"}
			],
			editModal: {
				visible: false,
				title: "Edit Equipment Type",
				record: {}
			},
			categoryFields: [
				{label: "Name",key:"name"}
			],
			catName: "",
			equipmentCategories: [],
			loading: true
		}
	},
	computed: {
		mutatedTypes() {
			return this.$store.equipmentTypes.map(type => {
				type.chargeOutRates = parseFloat(type.charge_out_rate).toCurrency() + "/hour"

				try {
					let chargeOutRatesObj = JSON.parse(type.charge_out_rates_json)

					let chargeOutRatesList = []

					Object.keys(chargeOutRatesObj).forEach(key => {
						if (chargeOutRatesObj[key].enabled) {
							let rateFormatted = +chargeOutRatesObj[key].rate
							rateFormatted = rateFormatted.toCurrency()

							chargeOutRatesList.push(rateFormatted + "/" + key) 
						}
					})

					type.chargeOutRates = chargeOutRatesList.join(", ")
				}
				catch (e) {}

				type.catName = ""
				if ("EquipmentCategory" in type && type.EquipmentCategory)
					type.catName = type.EquipmentCategory.name

				return type
			})
		}
	},
	methods: {
		panelItemClick(item,index) {
			this.activeSection = item
		},
		editType(record) {
			this.editModal.visible = true
			this.editModal.record = JSON.parse(JSON.stringify(record))
			this.editModal.title="Edit Equipment Type"
		},
		newType() {
			let vm = this

			this.editModal.visible = true
			this.editModal.record = {
				name: "",
				charge_out_rate: null
			}
			this.editModal.title = "Add New Equipment Type"
		},
		addCategory() {
			let vm = this

			let payload = {
				name: this.catName
			}

			this.postData("EquipmentCategory/save",payload,true).then(response => {
				if (response.success) {
					vm.fetchCategories()
				}
			})
		},
		fetchTypes() {
			let vm = this

			this.spinner(true)
			this.loading = true

			let params = {
				include: ["EquipmentCategory"]
			}

			this.getJSON("EquipmentType/get",params).then(response => {
				vm.spinner(false)
				vm.loading = false

				vm.$store.equipmentTypes = response.data

			})
		},
		fetchCategories() {
			let vm = this

			this.spinner(true)
			this.loading = true

			this.getJSON("EquipmentCategory/get").then(response => {
				vm.spinner(false)
				vm.loading = false

				vm.equipmentCategories = response.data
				vm.$store.equipmentCategories = response.data
			})
		}
	},
	created() {
		this.fetchTypes()
		this.fetchCategories()
	}
}
</script>